export function formatDate(input) {
  if (input === null || input === undefined) return "-";
  var d = new Date(input);
  if (isNaN(d.getTime())) return "-";
  var day = String(d.getDate()).padStart(2, "0");
  var month = String(d.getMonth() + 1).padStart(2, "0");
  var year = d.getFullYear();
  var hours = d.getHours();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  var minutes = String(d.getMinutes()).padStart(2, "0");
  return day + "-" + month + "-" + year + " " + hours + ":" + minutes + " " + ampm;
}

export function nullCheck(input) {
  let data = input;
  if (input === null || input === undefined) {
    data = "-";
  }
  return data;
}

export function nullCheckArray(input) {
  let data = input;
  if (input === null || input === undefined) {
    data = [];
  }
  return data;
}

export function transferTypeCheck(input) {
  let type;
  switch (input) {
    case 100:
      type = "UPI";
      break;
    case 200:
      type = "Crypto";
      break;
    case 300:
      type = "Mobikwik";
      break;
    case 400:
      type = "Bank Transfer";
      break;
    case 500:
      type = "Cash";
      break;
    default:
      type = input;
      break;
  }
  return type;
}

export function typeCheck(input) {
  let type;
  switch (input) {
    case "Deposit:crypto":
      type = "Crypto";
      break;
    case "Deposit:fiat":
      type = "Fiat";
      break;
    case "Withdraw:fiat":
      type = "Crypto";
      break;
    case "Withdraw:crypto":
      type = "Fiat";
      break;

    default:
      type = input;
      break;
  }
  return type;
}
